import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { TextWithFeatureImageWrapper } from './TextWithFeatureImage.style'
import { Wrapper } from '../../Container/Container.style'

import Image from '../../../shared/Image'

export default function TextWithFeatureImage({ title, textWithFeatureImage }) {
  return (
    <TextWithFeatureImageWrapper>
      <Wrapper>
        <h3 className="wow fadeIn">{title}</h3>
        {textWithFeatureImage && (
          <ul
            className={textWithFeatureImage.length < 3 && 'center-block'}
          >
            {textWithFeatureImage.map(item => {
              return (
                <li key={item.id} className="wow fadeInLeft" data-wow-offset="100">
                  <div>
                    <Image
                      src={item.image.imageFile.file.url}
                      alt={item.image.altText}
                    />
                    <div className="description">
                      {item.title && <h5>{item.title}</h5>}

                      {item.description && (
                        <div
                          className="productDescription"
                          dangerouslySetInnerHTML={{
                            __html: item.description.childMarkdownRemark.html,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        )}
      </Wrapper>
    </TextWithFeatureImageWrapper>
  )
}

export const TextWithFeatureImageItemFragment = graphql`
  fragment TextWithFeatureImageItemFragment on ContentfulTextWithFeatureImage {
    id
    title
    description {
      childMarkdownRemark {
        html
      }
    }
    image {
      url
      altText
      imageFile {
        file {
          url
        }
      }
    }
  }
`

export const TextWithFeatureImageFragment = graphql`
  fragment TextWithFeatureImageFragment on ContentfulTextWithFeatureImageContainer {
    title
    textWithFeatureImage {
      ...TextWithFeatureImageItemFragment
    }
  }
`

TextWithFeatureImage.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string,
    altText: PropTypes.string.isRequired,
    imageFile: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  textWithFeatureImage: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        html: PropTypes.string,
      }),
    }),
  }).isRequired,
}
